import dayjs from 'dayjs';

import { vimeoRegex, youtubeRegex } from '../constants/regex';
import { DropdownOption } from '../types/shared/DropdownOption';

export function isEmpty(item: any): boolean {
    if (Array.isArray(item)) return !item.length;
    if (typeof item === 'string') return !item.trim().length;
    if (item instanceof Date) return isNaN(item.valueOf());
    if (typeof item === 'object') return isObjEmpty(item);
    if (typeof item === 'number') return false;

    return !item;
}

function isObjEmpty(obj: Record<string, unknown>): boolean {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
}

export function convertArrToObj<T>(arr: T[], field: string = 'id'): Record<string, T> {
    return arr.reduce<Record<string, T>>((acc, item) => {
        // todo
        //@ts-ignore
        acc[item[field]] = item;
        return acc;
    }, {});
}

export function getDaysDifference(firstDate: dayjs.Dayjs, secondDate: dayjs.Dayjs): number {
    return secondDate.diff(firstDate, 'day');
}

export const getS3Filename = (s3Link: string): string => {
    return s3Link.split('/').pop() || '';
};

export const findRoleMatch = (rolesA: number[], rolesB: number[]): boolean => {
    const matches = rolesA.filter(r => !!rolesB.includes(r));
    return !!matches.length;
};

export const formatMoney = (amount: number) => {
    return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

export function getFileName(src: any) {
    return src.match('[^/]*$')[0];
}
export const areArraysEqual = (a: any[], b: any[]): boolean => {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
};

export const formatFieldValue = (value: string | number | null): string => {
    if (!!value) return value + '';
    return '--';
};

export function getVideoEmbedUrl(url: string) {
    const youtubeMatch = url.match(youtubeRegex);
    const vimeoMatch = url.match(vimeoRegex);

    if (youtubeMatch && youtubeMatch[2].length === 11) {
        return `https://www.youtube.com/embed/${youtubeMatch[2]}`;
    }

    if (vimeoMatch) {
        return `https://player.vimeo.com/video/${vimeoMatch[1]}?h=025ef04d15&color=ff9933&title=0&byline=0&portrait=0`;
    }

    return null;
}

export const getColor = (score: number | null | undefined) => {
    if (!score) return '';
    if (score <= 1) return 'red';
    else if (score <= 3) return 'yellow';
    else return 'green';
};

export const removeInvalidSelectValues = <V>(
    values: Array<V>,
    options: Array<DropdownOption<V>>,
) => {
    return values.filter(_value => options.find(({ value }) => _value === value));
};

export function bytesToMB(bytes: number) {
    return bytes / 1024 / 1024;
}
